var IconButton    = require("app/ui/IconButton"),
    config        = require("app/config"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    icons         = require("app/theme/icons"),
    kind          = require("enyo/kind");

module.exports = kind(/** @lends  app.Following.FollowButton.prototype */ {

    /**
     * @private
     */
    name: "app.Following.FollowButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-following-follow-button",

    /**
     * @private
     */
    theme: "neutral-ghost",

    /**
     * @type  {string}
     * @public
     */
    loadingCaption: "app.Following.FollowButton.loadingCaption",

    /**
     * @type  {string}
     * @public
     */
    addCaption: "app.Following.FollowButton.addCaption",

    /**
     * @type  {string}
     * @public
     */
    addingCaption: "app.Following.FollowButton.addingCaption",

    /**
     * @type  {string}
     * @public
     */
    removeCaption: "app.Following.FollowButton.removeCaption",

    /**
     * @type  {string}
     * @public
     */
    removingCaption: "app.Following.FollowButton.removingCaption",

    /**
     * @type  {string}
     * @public
     */
    loadingTooltip: "app.Following.FollowButton.loadingTooltip",

    /**
     * @type  {string}
     * @public
     */
    addTooltip: "app.Following.FollowButton.addTooltip",

    /**
     * @type  {string}
     * @public
     */
    addingTooltip: "app.Following.FollowButton.addingTooltip",

    /**
     * @type  {string}
     * @public
     */
    removeTooltip: "app.Following.FollowButton.removeTooltip",

    /**
     * @type  {string}
     * @public
     */
    removingTooltip: "app.Following.FollowButton.removingTooltip",

    /**
     * @type  {string}
     * @public
     */
    loadingIcon: icons["app.Following.FollowButton.loading"],

    /**
     * @type  {string}
     * @public
     */
    unfollowIcon: icons["app.Following.FollowButton.unfollow"],

    /**
     * @type  {string}
     * @public
     */
    followIcon: icons["app.Following.FollowButton.follow"],

    /**
     * The mediaItem
     *
     * @type  {?Object}
     * @public
     */
    mediaItem: null,

    /**
     * @public
     */
    showCaption: true,

    /**
     * @public
     */
    showToast: true,

    /**
     * @private
     */
    isRemovingFollow: false,

    /**
     * @private
     */
    isAddingFollow: false,

    /**
     * @private
     */
    addFollowFailMessage: null,

    /**
     * @private
     */
    deleteFollowFailMessage: null,

    /**
     * @private
     */
    observers: {
        update: ["mediaItem", "showCaption", "isAddingFollow", "isRemovingFollow"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            // TODO: Something to track follow state
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $authService     = this.app.$.authService,
            $i18nService     = this.app.$.i18nService,
            mediaItem        = this.get("mediaItem") || null,
            showCaption      = this.get("showCaption"),
            isAddingFollow   = this.get("isAddingFollow"),
            isRemovingFollow = this.get("isRemovingFollow"),
            isFollowing;

        // No media item or following not supported for this media type
        // TODO: Something to track follow state
        if (!mediaItem
            || !get(config, "following.enabled", false)
            || get(config, "follow.contentTypes", []).indexOf(mediaItem.type) === -1) {
            this.hide();

            return;
        }

        // User is still authenticating
        if ($authService.isLoggedIn === 0) {
            // Css flags
            !this.hasClass("loading") && this.addClass("loading");

            while (this.hasClass("active")) {
                this.removeClass("active");
            }

            // Content
            this.set("icon", this.loadingIcon);
            this.set("caption", showCaption ? $i18nService.getString(this.get("loadingCaption")) : null);
            this.setAttribute("title", $i18nService.getString(this.get("loadingTooltip")));
        }

        // Everyting is loaded
        else {
            // TODO: Something to track follow state
            this.set("isFollowing", false);

            // CSS loading flag
            if (isAddingFollow || isRemovingFollow) {
                !this.hasClass("loading") && this.addClass("loading");
            }
            else {
                while (this.hasClass("loading")) {
                    this.removeClass("loading");
                }
            }

            // CSS active flag
            if (isFollowing) {
                !this.hasClass("active") && this.addClass("active");
            }
            else {
                while (this.hasClass("active")) {
                    this.removeClass("active");
                }
            }

            // Content for Adding Follow state
            if (isAddingFollow) {
                this.set("icon", this.loadingIcon);
                this.set("caption", showCaption ? $i18nService.getString(this.get("addingCaption")) : null);
                this.setAttribute("title", $i18nService.getString(this.get("addingTooltip")));
            }

            // Content for Removing Follow state
            else if (isRemovingFollow) {
                this.set("icon", this.loadingIcon);
                this.set("caption", showCaption ? $i18nService.getString(this.get("removingCaption")) : null);
                this.setAttribute("title", $i18nService.getString(this.get("removingTooltip")));
            }

            // Content for Following state
            else if (isFollowing) {
                this.set("icon", this.unfollowIcon);
                this.set("caption", showCaption ? $i18nService.getString(this.get("removeCaption")) : null);
                this.setAttribute("title", $i18nService.getString(this.get("removeTooltip")));
            }

            // Content for Unfollowed state
            else {
                this.set("icon", this.followIcon);
                this.set("caption", showCaption ? $i18nService.getString(this.get("addCaption")) : null);
                this.setAttribute("title", $i18nService.getString(this.get("addTooltip")));
            }
        }

        this.show();
    },

    /**
     * @private
     */
    tap: function() {
        // TODO: Toggle follow state
    },

    /**
     * @private
     */
    userRequired: function() {
        // TODO
    },

    /**
     * @private
     */
    addFollow: function() {
        // TODO
    },

    /**
     * @private
     */
    removeFollow: function() {
        // TODO
    },

    /**
     * @private
     */
    onAddFollowSuccess: function() {
        // TODO
    },

    /**
     * @private
     */
    onAddFollowFailed: function() {
        // TODO
    },

    /**
     * @private
     */
    onDeleteFollowSuccess: function() {
        // TODO
    },

    /**
     * @private
     */
    onDeleteFollowFailed: function() {
        // TODO
    }

});
